// file: components/MediaVideoModal.jsx
import {
  CloseOutlined,
  PauseOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { ConfigProvider, Modal, Progress } from "antd";
import { FaDownload } from "react-icons/fa6";
import { standardizeVolume } from "../../utils/Utils";
import { SmartVideoPlayer } from "../customComponent/SmartVideoPlayer";
import { useGlobalDownloader } from "../../context/global/DownloadProvider";
import { useCallback, useEffect, useMemo, useState } from "react";

const MediaVideoModal = ({ open, onClose, shortName, file }) => {
  // 1. Sử dụng useGlobalDownloader
  const {
    downloads,
    startDownload,
    cancelDownload,
    pauseDownload,
    resumeDownload,
    DOWNLOAD_STATUS,
  } = useGlobalDownloader();

  // 2. Trích xuất state của đúng file đang hiển thị trong modal
  const [fileState, setFileState] = useState({});
  const fileNameToSave = file?.fileName || "Willo-video";

  const handleResumeDownload = (e) => {
    e.stopPropagation();
    resumeDownload(file?.resourceId, fileNameToSave);
  };

  const handlePauseDownload = (e) => {
    e.stopPropagation();
    pauseDownload(file?.resourceId);
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    startDownload(file?.resourceId, fileNameToSave, 0);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    cancelDownload(file?.resourceId); // Truyền resourceId để huỷ
  };

  const renderDownloadButton = useCallback(() => {
    switch (fileState?.status) {
      case DOWNLOAD_STATUS.PAUSED:
        return (
          <div className="flex gap-2">
            <button onClick={handleResumeDownload}>
              <PlayCircleOutlined
                style={{ fontSize: "20px", color: "green" }}
              />
            </button>
            <button onClick={handleCancel}>
              <CloseOutlined style={{ fontSize: "20px", color: "red" }} />
            </button>
          </div>
        );
      case DOWNLOAD_STATUS.DOWNLOADING:
        return (
          <>
            <button onClick={handlePauseDownload}>
              <PauseOutlined style={{ fontSize: "20px", color: "white" }} />
            </button>
            <button onClick={handleCancel}>
              <CloseOutlined style={{ fontSize: "20px", color: "white" }} />
            </button>
          </>
        );

      case DOWNLOAD_STATUS.SUCCESS:
        return (
          <button onClick={handleDownload}>
            <FaDownload style={{ fontSize: "20px", color: "white" }} />
          </button>
        );
      case DOWNLOAD_STATUS.ERROR:
        return (
          <div className="flex gap-2">
            <button onClick={handleCancel}>
              <CloseOutlined style={{ fontSize: "20px", color: "red" }} />
            </button>
          </div>
        );
      default:
        return (
          <button onClick={handleDownload}>
            <FaDownload style={{ fontSize: "20px", color: "white" }} />
          </button>
        );
    }
  }, [fileState?.status]);

  const progressRate = useMemo(() => {
    return (
      <div className="flex gap-[2px]">
        <div>
          {fileState?.progress
            ? standardizeVolume((fileState?.progress * file?.volume) / 100)
            : 0}
        </div>
        <div>/</div>
        <div>{standardizeVolume(file?.volume)}</div>
      </div>
    );
  }, [fileState?.progress]);

  useEffect(() => {
    setFileState(downloads[file?.resourceId]);
  }, [downloads]);

  return (
    <ConfigProvider
      theme={{ components: { Modal: { contentBg: "rgba(0, 0, 0, 0.7)" } } }}
    >
      <Modal
        open={open}
        footer={false}
        centered
        onCancel={onClose}
        className="preview-image-wrap"
        maskClosable={false}
      >
        <div className="display-imgage">
          <video
            src={file?.mainPath}
            controls
            autoPlay
            width="100%"
            controlsList="nodownload"
            className="img-preview"
          >
            The browser does not support the video tag.
          </video>
        </div>
        <span className="img-preview-file-name">{shortName}</span>
        <div className="wrap-item"></div>
        <div className="action-image">
          {/* 4. Cập nhật biến DOWNLOAD_STATUS */}
          {[DOWNLOAD_STATUS.DOWNLOADING].includes(fileState?.status) && (
            <div className="flex items-center gap-[2px]">
              <Progress
                className="w-36"
                percent={fileState?.progress}
                showInfo={false}
                strokeColor="#52c41a"
                size="small"
              />
              <div className="text-[grey] text-[10px] ml-2">{progressRate}</div>
            </div>
          )}

          <div className="flex justify-center gap-[10px]">
            <div className="icon-detail cursor-pointer">
              {renderDownloadButton()}
            </div>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export { MediaVideoModal };
